/**
 * BlogSLSiteHeaderLanguagesView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait BlogSLSiteHeaderLanguages
 */

import { useBlogSLSiteHeaderLanguagesLogic } from '@/hooks/traits/useBlogSLSiteHeaderLanguagesLogic';
import type { BlogSLSiteHeaderLanguagesConfig } from '@/hooks/traits/useBlogSLSiteHeaderLanguagesLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { BlogSLBlogView as BlogSLBlogViewEntity } from '@app/shared';
import { Button } from '@almadar/ui/components';
import { Menu } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface BlogSLSiteHeaderLanguagesViewProps {
  config?: Partial<BlogSLSiteHeaderLanguagesConfig>;
}

export function BlogSLSiteHeaderLanguagesView({ config: propsConfig }: BlogSLSiteHeaderLanguagesViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useBlogSLSiteHeaderLanguagesLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['BlogSLBlogView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="BlogSL" trait="BlogSLSiteHeaderLanguages">
      {slotWriter['main'] === 'INIT' ? (<Menu className={((([{ label: "English" as const, code: "en" as const, href: "/blog" as const }, { href: "/ar/blog" as const, code: "ar" as const, label: "العربية" as const }, { label: "Slovenščina" as const, code: "sl" as const, href: "/sl/blog" as const }]).length === 0)) ? "hidden" : ""} position="bottom-end" trigger={<Button icon="globe" variant="ghost" size="sm" label={String(__locale.toUpperCase())} />} items={Array.isArray(([{ href: "/blog" as const, code: "en" as const, label: "English" as const }, { href: "/ar/blog" as const, label: "العربية" as const, code: "ar" as const }, { label: "Slovenščina" as const, href: "/sl/blog" as const, code: "sl" as const }]).map((entry) => ({ label: (getNestedValue(entry, "label") ?? ""), id: (getNestedValue(entry, "code") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), href: (getNestedValue(entry, "href") ?? "") }))) ? (((([{ href: "/blog" as const, code: "en" as const, label: "English" as const }, { href: "/ar/blog" as const, label: "العربية" as const, code: "ar" as const }, { label: "Slovenščina" as const, href: "/sl/blog" as const, code: "sl" as const }]).map((entry) => ({ label: (getNestedValue(entry, "label") ?? ""), id: (getNestedValue(entry, "code") ?? ""), icon: (((getNestedValue(entry, "code") ?? "") === __locale) ? "check" : ""), href: (getNestedValue(entry, "href") ?? "") }))) as EntityRow[]) as ({ badge?: string | number; disabled?: boolean; event?: string; href?: string; icon?: string; id?: string; label: string; onClick?: never; subMenu?: never[]; title?: string; type?: 'item' | 'divider'; url?: string; variant?: 'default' | 'danger' })[]) : []} />) : null}
    </TraitScopeProvider>
  );
}

export default BlogSLSiteHeaderLanguagesView;
